// extracted by mini-css-extract-plugin
export var marginNegative = "_68-5 _68-3 _68-1";
export var marginPositive = "_68-4 _68-3 _68-1";
export var modalContent = "_68-6";
export var samplesTable = "_68-8";
export var samplesTableContainer = "_68-7";
export var statBox = "_68-a";
export var tableCell = "_68-1";
export var tableCellCenter = "_68-2 _68-1";
export var tableCellRight = "_68-3 _68-1";
export var tableHeader = "_68-0";
export var trackingNumber = "_68-9";